__turbopack_context__.v({
  "className": "ibm_plex_sans_thai_819d9a6-module___85M6W__className",
  "variable": "ibm_plex_sans_thai_819d9a6-module___85M6W__variable",
});
